import { render, staticRenderFns } from "./InfoTravauxComponent.vue?vue&type=template&id=0d18ec20&"
import script from "./InfoTravauxComponent.vue?vue&type=script&lang=js&"
export * from "./InfoTravauxComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoTravauxComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports